import { SET_ZONE_TYPE,SET_CURRENT_TAB } from "@store/constant";

export const setZoneType = (type: string) => {
  return {
    type: 'SET_ZONE_TYPE',
    payload: type
  };
};
export const setCurrentTab = (tab: string) => {
  return {
    type: 'SET_CURRENT_TAB',
    payload: tab
  };
};

export const setZoneModalData = (data:any) => {
  return {
    type: 'SET_ZONE_MODAL',
    payload: data
  };
};

export const setDistrictByZoneId = (key:any,value:any) => {
  return {
    type: 'SET_DISTRICT_BY_ZONE',
    payload: {key,value}
  };
};

export const setDistrictByStateId = (key:any,value:any) => {
  return {
    type: 'SET_DISTRICT_BY_STATE',
    payload: {key,value}
  };
};

export const setVillagesByBlockId = (key:any,value:any) => {
  return {
    type: 'SET_VILLAGE_BY_BLOCK_ID',
    payload: {key,value}
  };
};

export const setWardsByUlbId = (key:any,value:any) => {
  return {
    type: 'SET_WARD_BY_ULB_ID',
    payload: {key,value}
  };
};

export const setZoneByZoneId = (key:any,value:any) => {
  return {
    type: 'SET_ZONE_BY_ZONE_ID',
    payload: {key,value}
  };
};

export const setHealthBlockById = (key:any,value:any) => {
  return {
    type: 'SET_HEALTH_BLOCK_BY_ID',
    payload: {key,value}
  };
};

export const setStatesData = (data:any) => {
  return {
    type: 'SET_STATE',
    payload: data
  };
};

export const setZoneId = (data:any) => {
  return {
    type: 'SET_ZONE',
    payload: data
  };
};